<template>
    <nav class="main-nav fixed">
        <div class="brand">
            <router-link to="/"><img :src="require('../../assets/images/logo.png')"></router-link>
        </div>
        <div class="navigation">
            <ul>
                <li>
                    <router-link to="/">Accueil</router-link>
                </li>

                    <Dropdown>
                        <li v-for="(product, index) in require('../../data/products').default" :key="index">
                            <router-link :to="product.href">
                                {{ product.titles.fr.join(', ') }} /<span>{{ product.titles.en.join(', ') }}</span>
                            </router-link>
                        </li>
                    </Dropdown>

                <li>
                    <router-link to="/contact">Contact</router-link>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
    import Dropdown from "./Dropdown";

    export default {
        name: "AppHeader",
        components: {
            Dropdown
        }
    }
</script>

<style lang="scss" scoped>
    nav.main-nav {
        margin-bottom: 50px;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-content: stretch;
        padding: 0 20px;
        height: 110px;
        line-height: 90px;
        z-index: 1000;
        background-color: #ffffff;
        box-shadow: 0 3px 20px rgba(0, 0, 0, 0.27);

        & .brand {
            display: inherit;

            img {
                margin-top: 15px;
                height: 80px;
                width: 180px;
            }
        }

        & .navigation {
            display: inherit;
            margin-top: 10px;

            & ul {
                margin: 0;
                padding: 0;

                & li {
                    cursor: pointer;
                    display: inline-block;
                    padding: 0 10px;

                    & a {
                        padding: 5px;
                    }

                }
            }
        }
    }
</style>